import { useIntl } from "react-intl";

export default () => {
    const { formatMessage } = useIntl();

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                background: "#343a40",
                width: "100%",
                height: "100vh"
            }}
        >
            {formatMessage({ id: "loading_msg" })}
        </div>
    );
};